import React from 'react';
import { styled } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { Colors } from 'library';
import { BaseButton } from './BaseButton';

interface DeleteButtonProps {
    onClick: (e: React.MouseEvent) => void;
    variant?: 'subtle' | 'danger';
    size?: number;
    showOnHover?: boolean;
    className?: string;
}

export function DeleteButton({ onClick, variant = 'subtle', size = 18, showOnHover, className }: DeleteButtonProps) {
    return (
        <Button variant={variant} showOnHover={showOnHover} className={className} onClick={onClick}>
            <Delete sx={{ fontSize: size, color: Colors.mediumGrey }} />
        </Button>
    );
}

const Button = styled(BaseButton)<{ variant: 'subtle' | 'danger'; showOnHover?: boolean }>(
    ({ variant, showOnHover }) => ({
        padding: 6,
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...(showOnHover && {
            opacity: 0,
            transition: 'opacity 0.15s',
        }),
        '&:hover': {
            backgroundColor: variant === 'danger' ? Colors.lightRed : Colors.fill,
            '& svg': {
                ...(variant === 'danger' && { color: `${Colors.mediumRed} !important` }),
            },
        },
    }),
);
